/**
 * ABI for V3 Factory contract
 * Contains poolVersion method for getting pool version
 */
export const IV3FactoryABI = [
  {
    inputs: [
      { internalType: 'address', name: 'tokenA', type: 'address' },
      { internalType: 'address', name: 'tokenB', type: 'address' },
      { internalType: 'uint24', name: 'fee', type: 'uint24' },
    ],
    name: 'poolVersion',
    outputs: [{ internalType: 'uint256', name: 'version', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
] as const
